var _defs, _polygon, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpack4Solid33({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "a",
    points: "8 1 0.64 6.35 3.45 15 12.55 15 15.36 6.35 8 1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.73,12.78,2.85,4.91H4.47l1.19,5.41L7.1,4.91H9l1.38,5.5,1.21-5.5h1.6l-1.91,7.87H9.58L8,6.9,6.45,12.78Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpack4Solid33);
export default __webpack_public_path__ + "static/media/Symbolpack_4_solid_33.f5cd7850e718bbf4298e57c139387ce9.svg";
export { ForwardRef as ReactComponent };